import { ChevronLeft } from "lucide-react";
import { C, Panel, Chip, Serif, Label, Avatar } from "./ui";
import { CUSTOMERS, TIMELINE } from "./adminData";
import { DEPENDENTS } from "../consumer/data";

export default function CustomerDetail({ nav }) {
  const c = CUSTOMERS[0];
  return (
    <div>
      <button onClick={() => nav("customers")} data-testid="customer-back" style={{ display: "inline-flex", alignItems: "center", gap: 5, background: "none", border: 0, color: C.slate, fontSize: 13, cursor: "pointer", marginBottom: 14 }}>
        <ChevronLeft size={16} /> Customers
      </button>
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
        <Avatar name={c.name} color={C.red} />
        <div>
          <Serif size={24}>{c.name}</Serif>
          <div style={{ fontSize: 13, color: C.slate, marginTop: 2 }}>{c.insurer} · {c.plan} · <Chip color={C.red}>ResQ1 Consumer</Chip></div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)", gap: 16 }}>
        <div style={{ display: "grid", gap: 16, alignContent: "start" }}>
          <Panel>
            <Label style={{ marginBottom: 12 }}>Contact & cover</Label>
            {[["Cell", c.cell], ["Email", "maryanne.bekker@example.co.za"], ["ID number", "9001015555081"], ["Member since", "2018"], ["App", c.hasApp ? "Installed · active" : "Not installed"]].map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderTop: "1px solid rgba(26,30,36,0.06)", fontSize: 13 }}>
                <span style={{ color: C.slate }}>{k}</span><span style={{ fontWeight: 600 }}>{v}</span>
              </div>
            ))}
          </Panel>
          <Panel>
            <Label style={{ marginBottom: 12 }}>Household · {DEPENDENTS.length} dependents</Label>
            {DEPENDENTS.map((d) => (
              <div key={d.name} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderTop: "1px solid rgba(26,30,36,0.06)" }}>
                <Avatar name={d.name} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{d.name}</div>
                  <div style={{ fontSize: 11, color: C.slate }}>{d.role}</div>
                </div>
                <span style={{ fontSize: 11, fontWeight: 700, color: d.activated ? C.green : C.amber }}>{d.activated ? "active" : "pending"}</span>
              </div>
            ))}
          </Panel>
        </div>

        <div style={{ display: "grid", gap: 16, alignContent: "start" }}>
          <Panel>
            <Label style={{ marginBottom: 12 }}>Enrichment</Label>
            {[["Vehicle", "Toyota Fortuner · CA 152 981"], ["Home", "Constantia · Simah Armed Response"], ["Medical", "O+ · diabetes (managed)"]].map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderTop: "1px solid rgba(26,30,36,0.06)", fontSize: 13 }}>
                <span style={{ color: C.slate }}>{k}</span><span style={{ fontWeight: 600, textAlign: "right" }}>{v}</span>
              </div>
            ))}
          </Panel>
          <Panel>
            <Label style={{ marginBottom: 12 }}>Incident history</Label>
            {TIMELINE.slice(0, 3).map((e, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderTop: "1px solid rgba(26,30,36,0.06)", fontSize: 12 }}>
                <span style={{ color: C.ink }}>{e.e}</span>
                <span style={{ color: C.slate, fontFamily: "'JetBrains Mono', monospace" }}>{e.t}</span>
              </div>
            ))}
          </Panel>
        </div>
      </div>
    </div>
  );
}
